import { render, staticRenderFns } from "./PhotoView.vue?vue&type=template&id=2dbcd4cc&"
import script from "./PhotoView.vue?vue&type=script&lang=js&"
export * from "./PhotoView.vue?vue&type=script&lang=js&"
import style0 from "./PhotoView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports